import { Link } from "react-router-dom";
import logo from "../../Assets/logo.png";

const Logo = () => {
  return (
    <Link
      to={`/dashboard`}
      className={`flex items-center justify-center text-white text-4xl w-48 `}
    >
      <img src={logo} alt="Her Springboard" className="w-full h-auto max-w-[12rem] object-contain" />
    </Link>
  );
};

export default Logo;
